<template>
  <div id="eMeet">
    <div style="padding: 0 0.5rem 0.5rem;">
      <b-button variant="primary" tabindex="98"
        @click="save()"><b-icon icon="check"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>&nbsp;&nbsp;
      <b-button tabindex="99"
        @click="close()"><b-icon icon="x"/>&nbsp;{{$t('message.Close_cmd')}}</b-button>
    </div>
    <div class='well'
      style="margin-bottom:0; position: relative; overflow: auto; max-height: 29rem; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
      <table style="border:2.5px solid; padding:5px; width:100%;" rules="all" cellpadding='5'
        v-if="null != inputData">
        <tbody style="line-height:1.5rem;">
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" style="width:7.5rem;">會議單號：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:7rem;">
              {{0 == inputData.mId? '系統自動產生': inputData.no}}
            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">發佈人：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
              {{inputData.eId}} {{inputData.eName}}
            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">發佈單位：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
              {{inputData.uId}} {{inputData.uName}}
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">會議期間：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <table>
                <tr>
                  <td>
                    <b-form-datepicker v-model="inputData.sTime" :max="inputData.eTime" locale="zh-TW" tabindex="1"
                      :autofocus="true"></b-form-datepicker>
                  </td>
                  <td>
                    &nbsp;<span style="padding: 0.425rem 0 0;">至</span>&nbsp;
                  </td>
                  <td>
                    <b-form-datepicker v-model="inputData.eTime" :min="inputData.sTime" locale="zh-TW" tabindex="2"></b-form-datepicker>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">會議名稱：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <b-form-input placeholder="請輸入會議名稱" :maxlength="60" tabindex="3"
                v-model="inputData.title" />
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">會議紀錄：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <b-form-textarea type="textarea" placeholder="請輸入紀錄" tabindex="4"
                :rows="5"
                v-model="inputData.content"/>
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">會議心得：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <b-form-textarea type="textarea" placeholder="請輸入心得" tabindex="5"
                :rows="5"
                v-model="inputData.opinion"/>
            </td>
          </tr>
          <tr>
            <td class="ncut-edit-form-text">置頂排序：</td>
            <td class="ncut-base-form-ipt" colspan="5" style="padding: 1rem;">
              <b-form-input id="range-1" v-model="inputData.rankKey" type="range" min="0" max="100" tabindex="6"></b-form-input>
              <div class="mt-2">排序：<font size="+1" style="color:#411c35;">{{ inputData.rankKey }}</font>（預設為 0，可決定報表顯示置頂，數字越大順位越高。）</div>
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">說明：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <div v-html="memo"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as tools from '@/tool'

export default {
  name: 'eMeet',
  props: [
    'id'
  ],
  data () {
    return {
      isIE: false,
      inputData: null,
      memo: '無'
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    hideModal (event) {
      this.$emit('hideModal');
    },
    close() {
      this.$emit('hideModal');
    },
    checkSaveData () {
      let msg = '';

      if (tools.isNullOrEmpty(this.inputData.title)) {
        msg = '會議名稱';
      } else if (tools.isNullOrEmpty(this.inputData.content)) {
        msg = '會議紀錄';
      } else if (tools.isNullOrEmpty(this.inputData.opinion)) {
        msg = '會議心得';
      }
      return msg;
    },
    save () {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        this.inputData.sysId = this.sysId;
        this.inputData.userId = this.user.id;

        this.$http.put('./WebApi/Meet/SetMeet', this.inputData)
          .then((response) => {
            if (0 < response.data) {
                tools.showAlert(vm, 'success', '恭喜您,存檔成功');
                vm.mode = 2;
                vm.getMeetData(response.data);
                vm.$store.dispatch('actionReSetFlag2', true);
            }
            else {
                tools.showAlert(vm, 'danger', '對不起,存檔失敗');
            }
          })
          .catch(function (error) {
              tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error);
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,請輸入'.concat(msg).concat('!'));
      }
    },
    getMeetData: function (id) {
      var vm = this
      this.$http.get('./WebApi/Meet/GetMeet/'.concat(id))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data

            if (0 == vm.inputData.mId) {
              var today = new Date();
              var yy = today.getFullYear();
              var mm = today.getMonth();
              var dd =  today.getDate();
              vm.inputData.sysId = vm.sysId;
              vm.inputData.rankKey = 0;
              vm.inputData.sTime = today;
              vm.inputData.eTime = today;
              vm.inputData.eId = vm.user.id;
              vm.inputData.eName = vm.user.name;
              vm.inputData.uId = vm.user.dptcd;
              vm.inputData.uName = vm.user.dptnm;
            }
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })
      return this.$http
                 .get('./WebApi/Meet/GetMeet/'.concat(id));
    },
    getMemoData: function (id) {
      return this.$http
                 .get('./WebApi/Common/GetFormatByNo/'.concat(this.sysId).concat("/1/1"));
    },
  },
  created () {
    console.log('======created MinuTakerView =====');
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1 || navigator.userAgent.indexOf("Edge") > -1;

    let vm = this;
    this.mode = (this.id == 0? 1: 2);
    this.$http.all([this.getMemoData()])
              .then(vm.$http.spread(function (data1) {
                      if (!tools.isNull(data1)) {
                        vm.memo = data1.data
                      }
                      vm.getMeetData(vm.id);

                    }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
